import { GoogleTagManager } from '@next/third-parties/google';

import { isProd } from '@/constant/env';
import { currentLocaleConfig } from '@/lib/i18n/localeSpecific';

type DataLayerType = Record<string, unknown>;

type WindowWithDataLayer = Window & {
  dataLayer: DataLayerType[];
};

declare const window: WindowWithDataLayer;

export const sendPageViewEvent = (
  pathname: string,
  previousPathname: string | null
) => {
  sendGAEvent({
    event: 'page_view',
    page_title: document.title,
    page_path: pathname,
    previous_page_path: previousPathname,
  });
};

export const sendVirtualPageViewEvent = (
  pathname: string,
  previousPathname: string | null
) => {
  sendGAEvent({
    event: 'virtual_page_view',
    page_title: document.title,
    page_path: pathname,
    previous_page_path: previousPathname,
  });
};

export function sendGAClickEvent(eventData: DataLayerType) {
  sendGAEvent({ event: 'element_click', eventData });
}

export function sendGAEvent(eventData: DataLayerType) {
  if (!isProd) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(eventData);
}

export const TrackingScripts = () => {
  return (
    <>
      <GoogleTagManager gtmId={currentLocaleConfig().gtmId} />
    </>
  );
};
